import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable()
export class IdGeneratorService {
  generateGuid(partialKey?: string): string {
    if (partialKey) {
      return `${partialKey}-${uuidv4()}`;
    }

    return uuidv4();
  }
}
